// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".ce35944f57c5058a5890f61f517a409ec6e319e7.chunk.bundle.js";
};